import React from 'react';
import { useThemeContext, WizardContext } from '../../../../context';
import { SelectList } from '../../SelectList';
import { WizardButton } from '../../../Shared/Wizard';
import { StyledLabel, WizardActions } from '../../../Shared/Styled';
import { SelectItem } from '../../../../types';
import { SearchBox } from '../../Search';

export interface IModelSelectionProps {
  items: SelectItem[];
  selected?: string;
  onSearch: (input: string) => void;
  onClear: () => void;
  onChange: (input: string) => void;
}

export function IModelSelection({
  items,
  selected,
  onClear,
  onSearch,
  onChange,
}: IModelSelectionProps) {
  const theme = useThemeContext();
  return (
    <WizardContext.Consumer>
      {({ goto }) => (
        <div
          id='IModelSelection'
          style={{
            display: 'inline-flex',
            width: '100%',
            flexDirection: 'column',
          }}
        >
          <StyledLabel style={{ marginTop: '9px' }} themeStr={theme}>
            <span>Select iModel</span>
          </StyledLabel>
          <SearchBox
            placeholder={'Enter filter criteria'}
            onSearch={onSearch}
            onClear={onClear}
            onChange={onChange}
            inputValue={undefined}
            isFilterBox={true}
            theme={theme}
          />
          <SelectList
            items={items}
            selected={selected}
            selectedProperty='value'
          />
          <WizardActions>
            <WizardButton
              direction='back'
              label={'Service'}
              onClick={() => goto('choose-service')}
              theme={theme}
            />
            <WizardButton
              direction='forward'
              label='Named Version'
              disabled={items.length === 0 || !selected}
              onClick={() => goto('choose-named-version')}
              theme={theme}
            />
          </WizardActions>
        </div>
      )}
    </WizardContext.Consumer>
  );
}
